import React, { useState, useEffect } from "react";
import {
  onboardedByDropdown,
  referenceTypeDropdown,
} from "../../../../../data/freezedData";

import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { addClientData } from "../../../../../data/redux/slice/clientOnboardDataSlice";
import {
  colorBlack,
  colorWhite,
  primaryColor,
} from "../../../../../utility/constants/colorManager";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import ComissionContainer, {
  checkObjHasAllValue,
} from "../../../../components/ui_comps/ComissionContainer";
import { API_ENDPOINT } from "../../../../../data/network/services/ApiEndpoint";
import {
  FLAT,
  STATUS_CODE_200,
} from "../../../../../utility/constants/valueConstants";
import { formDataPush } from "../../clients/client_onboard/ResellerDetails";
import { addResellerDataAction } from "../../../../../data/redux/slice/resellerDataSlice";
import {
  SS_AUTH_TOKEN,
  SS_EMAIL,
  SS_FIRST_NAME,
  SS_LAST_NAME,
  SS_ROLE,
  SS_USER_HASH_ID,
} from "../../../../../utility/constants/secureStorageManager";
import secureStorage from "../../../../../services/secureStorage";
import { fetchSalesDropDownList } from "../../../../../services/fetchDropdownListData";
import CustomSelect from "../../../../components/main_comps/custom_select";

function ClientReference({ onClickBack, onSuccess }) {
  const [salesReference, setSalesReference] = useState({
    label: "Select Sales",
    value: "",
  });
  const [onboardedBy, setOnboardedBy] = useState("");
  const [commissionRate, setCommissionRate] = useState([]);
  const [flatData, setFlatData] = useState([]);
  const [type, setType] = useState([]);
  const [loading, setLoading] = useState(false);
  const resellerData = useSelector((state) => state.onboardResellerReducer);

  const [userId, setUserId] = useState("");
  const [role, setRole] = useState("");
  const [createdBy, setCreatedBy] = useState({});

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
  };

  const textStyle = {
    fontSize: 12,
    color: "#6C6B6B",
    margin: "5px 0px",
  };

  const getData = async () => {
    const id = await secureStorage.getItem(SS_USER_HASH_ID);
    const role = await secureStorage.getItem(SS_ROLE);
    const firstName = await secureStorage.getItem(SS_FIRST_NAME);
    const lastName = await secureStorage.getItem(SS_LAST_NAME);
    const email = await secureStorage.getItem(SS_EMAIL);
    setCreatedBy({ email, userName: firstName + " " + lastName });
    setUserId(id);
    setRole(role);
  };
  useEffect(() => {
    getData();
  }, []);
  const salesList = useSelector((state) => state.dropDownListSlice.salesList);

  const onClickAddReseller = (data) => {
    setLoading(true);
    const formdata = formDataPush({ ...resellerData, ...data });
    const token = secureStorage.getItem(SS_AUTH_TOKEN);

    fetch(API_ENDPOINT.core_url + "reseller/create", {
      body: formdata,
      headers: {
        Authorization: "Bearer " + token,
      },
      method: "POST",
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          onSuccess();
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    dispatch(
      fetchSalesDropDownList({
        userRefId: "",
      })
    );
  }, []);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <div>
        <p style={textStyle}>Sales Reference</p>
        <CustomSelect
          value={salesReference}
          onChange={(data) => {
            setSalesReference(data);
          }}
          options={salesList}
        />
      </div>

      {/* <div>
        <p style={textStyle}>Onboarded By</p>
        <CustomInput
          value={onboardedBy}
          onChange={(data) => setOnboardedBy(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Select Name"
          validator="name"
          type="select"
          dropdownStyle={{
            ...inputStyle,
          }}
          inputStyles={{
            backgroundColor: "transparent",
            border: "none",
            boxShadow: "none",
            width: "100%",
          }}
          options={onboardedByDropdown}
        />{" "}
      </div> */}

      <div>
        <p style={textStyle}>Reseller comission</p>
        <ComissionContainer
          onClickNext={(data, flatData, type) => {
            setCommissionRate(data);
            setFlatData(flatData);
            setType(type?.toUpperCase());
          }}
          isSlabRequired={true}
        />
      </div>

      <div
        style={{
          display: "flex",
          gap: 20,
          justifyContent: "center",
          margin: "15px 0px",
        }}
      >
        <CustomButton
          title="Cancel"
          styles={{
            backgroundColor: colorWhite,
            border: "1px solid black",
            padding: 0,
            height: "auto",
            padding: "10px",
          }}
          textStyles={{
            color: colorBlack,
          }}
          onClick={onClickBack}
        />{" "}
        <CustomButton
          title="Next"
          styles={{
            backgroundColor: primaryColor,
            border: "1px solid black",
            padding: 0,
            height: "auto",
            padding: "10px 25px",
          }}
          textStyles={{
            color: colorWhite,
          }}
          onClick={() => {
            if (
              checkObjHasAllValue({
                salesReference,
              }) &&
              (type === FLAT
                ? checkObjHasAllValue({
                    ...flatData,
                  })
                : checkObjHasAllValue({
                    ...commissionRate,
                  }))
            ) {
              let obj = [];
              if (type === FLAT) {
                obj.push(flatData);
              } else {
                obj.push(...commissionRate);
              }

              onClickAddReseller({
                salesReference: JSON.stringify({
                  userName: salesReference.label,
                  email: salesReference.email,
                  id: salesReference.value,
                }),
                onboardedBy: createdBy.userName,
                comissionType: type,
                comissionRate: JSON.stringify([...obj]),
                userRefId: userId,
                role,
                createdBy: JSON.stringify(createdBy),
              });
            } else {
              enqueueSnackbar("Please fill below fields", {
                variant: "error",
              });
            }
          }}
          disabled={false}
          loading={loading}
        />
      </div>
    </div>
  );
}

export default ClientReference;
